<template>
  <v-dialog :value="true" max-width="640" @input="$emit('close')">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon left>mdi-map-marker</v-icon>
        {{ $t('meter-device.connected-vehicle.place-map-title') }}
        <v-spacer />
        <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text>
        <div v-if="label" class="caption grey--text mb-2">{{ label }}</div>
        <div style="height: 420px; width: 100%;">
          <l-map ref="map" :zoom="16" :center="center" :options="{ scrollWheelZoom: false }" style="height: 100%; border-radius: 6px;" @ready="onMapReady">
            <l-tile-layer :url="url" :options="{ maxNativeZoom: 18, maxZoom: 19 }" />
            <l-circle-marker :lat-lng="center" :radius="9" color="#ffffff" :weight="2" :fill-opacity="0.9" fill-color="#1976d2">
              <l-tooltip>{{ coordsText }}</l-tooltip>
            </l-circle-marker>
          </l-map>
        </div>
        <div class="caption grey--text mt-2 d-flex align-center">
          <v-icon x-small class="mr-1">mdi-crosshairs-gps</v-icon>{{ coordsText }}
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// A minimal leaflet map showing the exact point of a charge that matched no known location (the raw fix
// coordinates we persist for those). Uses the project's own tile server — no external map provider.
import { LMap, LTileLayer, LCircleMarker, LTooltip } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "ConnectedVehicleChargePlaceMapDialog",
  components: { LMap, LTileLayer, LCircleMarker, LTooltip },
  props: {
    latitude: { type: Number, required: true },
    longitude: { type: Number, required: true },
    label: { type: String, default: null },
  },
  data() {
    return { url: "https://tile.api.zeborne.com/{z}/{x}/{y}.png" };
  },
  computed: {
    center() {
      return [this.latitude, this.longitude];
    },
    coordsText() {
      return `${this.latitude.toFixed(6)}, ${this.longitude.toFixed(6)}`;
    },
  },
  methods: {
    onMapReady() {
      const map = this.$refs.map && this.$refs.map.mapObject;
      if (!map) return;
      // The dialog animates open, so the map container has no size at init → tiles render offset until a resize.
      // Recompute the size once (next tick) and again after the open transition settles, then recentre.
      this.$nextTick(() => map.invalidateSize());
      setTimeout(() => {
        map.invalidateSize();
        map.setView(this.center, 16);
      }, 300);
    },
  },
};
</script>
